import makeStyles from "@material-ui/core/styles/makeStyles";

const classes = makeStyles((theme) => ({
  root: {},
  filterActionButton: {
    marginBottom: theme.spacing(1),
    '& + &': {
      marginLeft: theme.spacing(1)
    }
  }
}));

export default classes;
